<div class="login-container">
  <div class="login-card">
    <app-header heading="Reset Password" subheading="Please capture your new password"></app-header>

    <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" style="margin-top: 1rem;">
      <!-- Hidden username field for accessibility -->
      <input type="text" name="username" autocomplete="username" style="display:none;" />

      <div class="form-group">
        <input id="password" type="password" formControlName="password" placeholder="Enter new password" autocomplete="new-password" />
      </div>
      <div class="form-group">
        <input id="confirmPassword" type="password" formControlName="confirmPassword" placeholder="Confirm new password" autocomplete="new-password" />
      </div>

      <div class="form-footer">
        <button type="submit" class="sign-in-btn" [disabled]="resetPasswordForm.invalid || isLoading">
          {{ isLoading ? 'Updating...' : 'Update Password' }}
        </button>
      </div>

      <p *ngIf="message" class="error-message">{{ message }}</p>
    </form>

    <p class="create-account">
      <a routerLink="/login">Back to login</a>
    </p>
  </div>
</div>